export const track = <T>(name: string, payload?: T) => {
  if (typeof window !== 'undefined') {
    window.LIFE_CYCLE_EVENT_BUS?.trigger(name, payload);
  }
};
